import type { TransactionsConfig } from '../TransactionsConfig';

export const transactions: TransactionsConfig = {
    enabled: false,
    mode: 'COMPLEX',
};
